<app-modal-detail-activities [visible]="shouldShowSanctionTypeModal" (handleClose)="closeSanctionTypeModal()" [dataToShow] = "modalData" >
</app-modal-detail-activities>

<div class="container u-mt60 ">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-9">
      <h1 class="txt txt--title">
        Actividades recientes
      </h1>
      <a class="back back--small u-mt10 u-mb40" routerLink="/dashboard">
        <strong>Volver</strong>
      </a>
    </div>
    <div class="col-md-3">
      <div class="u-desktop">
        <div class="form autocomplete autocomplete--small">
          <input
          type="text"
          id="iexample"
          name="filterAct"
          class="form__search"
          placeholder="Buscar"
          [(ngModel)]= "searchText">
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="table table--history">
        <div class="thead">
          <div class="tr">
            <div class="th hover-hand" (click)="setOrder('asset')">
                <div class="table-head headerTable">
                <p> Asset</p>
                <div class="sorting-arrows-container">
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting ASC -->
                    <div [hidden]="(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'asset' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting DESC -->
                    <div [hidden]="(order === 'asset' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                </div>
                <!-- solo una flecha mmantener haste que  el cliente este  completamente conforme -->
                <!-- <div style="height: 100%; margin-top: 8px; display:flex; align-items: center">

                  <div *ngIf="order === 'asset' && orderStatus === 2">
                    <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                  </div>
                  <div *ngIf="order === 'asset' && orderStatus === 3">
                    <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                  </div>


              </div> -->
                </div>
            </div>
            <div class="th hover-hand" (click)="setOrder('requirementType')">
                <div class="table-head headerTable">
                    <p>Tipo actividad</p>
                    <div class="sorting-arrows-container">
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'requirementType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting ASC -->
                        <div [hidden]="(order === 'requirementType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'requirementType' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting DESC -->
                        <div [hidden]="(order === 'requirementType' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="th hover-hand" (click)="setOrder('createdAt')">
                <div class="table-head headerTable">
                    <p>Fecha actividad</p>
                    <div class="sorting-arrows-container">
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'createdAt' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting ASC -->
                        <div [hidden]="(order === 'createdAt' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'createdAt' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting DESC -->
                        <div [hidden]="(order === 'createdAt' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="th hover-hand" (click)="setOrder('id')">
                <div class="table-head headerTable">
                    <p>Nº solicitud</p>
                    <div class="sorting-arrows-container">
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'id' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting ASC -->
                        <div [hidden]="(order === 'id' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'id' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting DESC -->
                        <div [hidden]="(order === 'id' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="th hover-hand" (click)="setOrder('licenseId')">
                <div class="table-head headerTable">
                     <p>Nº licencia</p>
                     <div class="sorting-arrows-container">
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'licenseId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting ASC -->
                        <div [hidden]="(order === 'licenseId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                          <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                      <div class="arrow-container">
                        <!-- Sorting Disabled -->
                        <div [hidden]="!(order === 'licenseId' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                        </div>
                        <!-- Sorting DESC -->
                        <div [hidden]="(order === 'licenseId' && orderStatus === 3)">
                          <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="tbody desktop">

               <div class="tr row-height" *ngFor="let activity of activitiesUser |filterTable : searchText|  orderBy : orderActivities : reverse : true  | paginate : config; let i = index">
                <div class="td td--number row-content"><p class="row-field">{{activity.asset}}</p></div>

                  <div class="td td--button showTogleAct  row-content"><p class="row-field">{{activity.requirementType}}</p>
                  </div>
                   <div class="td td--status row-content"><p class="row-field"><span class="mr-2">Fecha:</span>{{activity.createdAt |dateFromBack }}</p></div>

                  <div class="td td--body  desktopInfoActivity row-content" ><p class="row-field">{{activity.id}}</p></div>
                  <div class="td td--body  desktopInfoActivity row-content"><p class="row-field">{{activity.licenseId}}</p></div>

              </div>
        </div>
        <div class="tbody mobile">

          <mat-accordion>

                 <div  *ngFor="let activity of activitiesUser| filterTable : searchText | orderBy : orderActivities : reverse : true | paginate : config; let i = index">
                  <mat-expansion-panel class="tableRowsResponsive" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header >
                  <mat-panel-title class="assetName">
                    <div class="containerP"><p>{{activity.asset}}</p></div>
                    </mat-panel-title>
                  <mat-panel-description class="descriptionAct">
                  <p>{{activity.requirementType}}</p>
                    <p class="textDate"><span class="mr-2">Fecha:</span>{{activity.createdAt |dateFromBack}}</p>

                  </mat-panel-description>
                  </mat-expansion-panel-header>
                   <div class="bodyDetail">
                  <p><span>Número de solicitud:</span>{{activity.id}}</p>
                  <p><span>Número de licencia:</span>{{activity.licenseId}}</p>
                   </div>

                </mat-expansion-panel>
        </div>

      </mat-accordion>
      </div>


  </div>

         <div class="u-right u-mt70" *ngIf="activitiesUser.length >  0">
    <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="config.currentPage = $event">
        <div class="custom-pagination">
          <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
            <span *ngIf="!p.isFirstPage()" (click)="p.previous()"> < </span>
            </div>
            <div class="page-number" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                  <span (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</span>
                <div *ngIf="p.getCurrent() === page.value">
                  <span>{{ page.label }}</span>
                </div>
            </div>
            <div class="pagination-next" [class.disabled]="p.isLastPage()">
              <span *ngIf="!p.isLastPage()" (click)="p.next()"> > </span>
            </div>
        </div>

      </pagination-template>
</div>

<!--<app-table
[headers]="headers"
[rows]="activitiesUser"
[tableType]="'table-activities'"
[tableStyleGeneral]="'tableGralStyleGrey'"
[colorBackground]="'headerTableGrey'"></app-table>
</div>-->



</div>

</div>
